export default __webpack_public_path__ + "static/media/digdes.7e8327d1.webp";